import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { PPToProductInstructionStatic } from "./PPToProductInstructionStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
}

export const PPToProductInstructionDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const PPToProductInstructionStore: PPToProductInstructionStatic = new PPToProductInstructionStatic();
